import numeral from 'numeral';

// This is the current formatCurrency implementation from portal web.
// TODO: This section needs to be replaced by formatCurrency from frontend-core.
// However the formatCurrency from the frontend-core and the formatCurrency from portal web are very different.
// So I'll keep the copy portal web version for now.

const currencySymbol = '$';
const decimal = 2;
const formatString = `${currencySymbol}0,0.${'0'.repeat(decimal)}`;

export const formatCurrency = (cents: number | string = 0, divisor: number = 100): string => {
	if (typeof cents !== 'number') {
		const sanitized = cents.replace(/\$/g, '');
		let parsedValue = parseFloat(sanitized);
		// eslint-disable-next-line no-restricted-globals
		if (isNaN(parsedValue)) return currencySymbol + cents;

		// eslint-disable-next-line no-param-reassign
		cents = parsedValue;
	}

	return numeral(cents / divisor).format(formatString);
};
